import React from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import Colors from '../constants/Colors';

const styles = StyleSheet.create({
  default: { color: Colors.veryDarkGray },
});

/**
 * A thin wrapper around react-native `Text` that defaults font scaling to false
 * and applies a default text color. Both are overridable per-call.
 * Short-term workaround for accessibility / theming defaults.
 * TODO: https://github.com/PlentifulApp/plentiful/issues/3643 (font scaling)
 * TODO: https://github.com/PlentifulApp/plentiful/issues/3625 (text color / theming)
 */
// eslint-disable-next-line import/prefer-default-export
export function AppText({ style, allowFontScaling = false, ...rest }: TextProps) {
  return <Text allowFontScaling={allowFontScaling} style={[styles.default, style]} {...rest} />;
}
